import React, { FC } from 'react';
import { CommonAppProviders } from '../../../doctrine/app/common-app/CommonAppProviders';
import { PublicCookiePolicy } from './cookie-policy/PublicCookiePolicy';
import { useShowLogin } from './home/useShowLogin';
import { useLoggedIn } from './useLoggedIn';

export const PublicCommon: FC = ({ children }) => {
  const isLoggedIn = useLoggedIn();
  return (
    <CommonAppProviders isLoggedIn={isLoggedIn}>
      <PublicConsumersUses>
        <PublicCookiePolicy>{children}</PublicCookiePolicy>
      </PublicConsumersUses>
    </CommonAppProviders>
  );
};

const PublicConsumersUses: FC = ({ children }) => {
  useShowLogin();
  return <>{children}</>;
};
